import axios from "axios";

const navItems = [
    {
        title: "知识点管理",
        icon: "el-icon-document",
        items: [
            {title: "词汇", url: "/word", permission: '/api/word/index'},
            {title: "语法", url: "/grammar", permission: '/api/grammar/index'},
            {title: "课文", url: "/kewen", permission: '/api/kewen/index'},
            {title: "句子", url: "/sentence", permission: '/api/sentence/index'},
            {title: "解释", url: "/graphictext", permission: '/api/graphic/graphic/index'},
            {title: "复习例句", url: "/review/sentences", permission: '/api/review/sentence/index'},
        ]
    },
    {
        title: "题目管理",
        icon: "el-icon-setting",
        items: [
            {title: "全部题目", url: "/exercise/index", permission: '/api/exercise/index'},
            {title: "词汇题目", url: "/kexercise/word", permission: '/api/exercise/index'},
            {title: "语法题目", url: "/kexercise/grammar", permission: '/api/exercise/index'},
            {title: "课文题目", url: "/kexercise/kewen", permission: '/api/exercise/index'},
            {title: "题目校对", url: "/exercise/check", permission: '/api/exercise/check/index'},
            {title: "题目解析", url: "/exercise/qa", permission: '/api/exercise/qa/index'},
            {title: "题目图片", url: "/exercise/files", permission: '/api/exercise/file-desc'},
        ]
    },
    {
        title: "水平测试",
        icon: "el-icon-setting",
        items: [
            {title: "词汇题目", url: "/testexercise/1", permission: '/api/test/exercise/index'},
            {title: "语法题目", url: "/testexercise/2", permission: '/api/test/exercise/index'},
        ]
    },
    {
        title: "课程管理",
        icon: "el-icon-setting",
        items: [
            {title: "课程编排", url: "/collection", permission: '/api/lesson/collection/index'},
            {title: "课程列表", url: "/lesson", permission: '/api/lesson/index'},
        ]
    },
    {
        title: "拼音管理",
        icon: "el-icon-setting",
        items: [
            {title: "题目", url: "/pinyinexercises", permission: '/api/pinyin/exercise/index'},
            {title: "拼音", url: "/pinyin", permission: '/api/pinyin/index'},
            {title: "介绍", url: "/pinyinintro", permission: '/api/pinyin/intro/index'},
            {title: "组合", url: "/pinyincomb", permission: '/api/pinyin/comb/index'},
            {title: "课程", url: "/pinyinlesson", permission: '/api/pinyin/lesson/index'},
        ]
    },
    {
        title: "Talk管理",
        icon: "el-icon-document",
        items: [
            {title: "话题列表", url: "/talk/topics", permission: '/api/talk/item/index'},
            {title: "猜词列表", url: "/talk/words", permission: '/api/talk/item/index'},
        ]
    },
    {
        title: "AI识图",
        icon: "el-icon-document",
        items: [
            {title: "词汇", url: "/aiimage/word", permission: 'cms-nav-aiimage'},
            {title: "句子", url: "/aiimage/sentence", permission: 'cms-nav-aiimage'},
        ]
    },
    {
        title: "基础数据",
        icon: "el-icon-setting",
        items: [
            {title: "语法分类", url: "/grammartype", permission: 'cms-nav-grammar-type'},
            {title: "题目类型", url: "/exercise/type", permission: 'cms-nav-exercise-type'},
            {title: "课文角色", url: "/kewen/role", permission: 'cms-nav-kewen-role'},
        ]
    },
    {
        title: "翻译管理",
        icon: "el-icon-setting",
        permission: '/api/locale/search',
        items: [
            {title: "全部", url: "/locale/all", permission: '/api/locale/search',},
            {
                title: "知识点翻译",
                permission: '/api/locale/search',
                items: [
                    {title: "词汇翻译", permission: '/api/locale/search', url: "/locale/word"},
                    {title: "语法翻译", permission: '/api/locale/search', url: "/locale/grammar"},
                    {title: "语法解释", permission: '/api/locale/search', url: "/locale/graphictranslation"},
                    {title: "课文例句", permission: '/api/locale/search', url: "/locale/kewensentence"},
                    {title: "语法例句", permission: '/api/locale/search', url: "/locale/grammarsentence"},
                    {title: "词汇例句", permission: '/api/locale/search', url: "/locale/wordsentence"},
                    {title: "其他例句", permission: '/api/locale/search', url: "/locale/othersentence"},
                    {title: "课程翻译", permission: '/api/locale/search', url: "/locale/lesson"},
                ]
            },
            {title: "题目内容翻译", url: "/locale/exercise", permission: '/api/locale/search',},
            {title: "题目解析页翻译", url: "/locale/exercise_trans", permission: '/api/locale/search',},
            {title: "Google翻译", url: "/translate/index", permission: '/api/locale/search',},
            {title: "拼音翻译", url: "/locale/pinyin", permission: '/api/locale/search',},
            {title: "帮助翻译", url: "/locale/help", permission: '/api/locale/search',},
            // {title: "Google翻译", url: "/locale/translate"},
            {
                title: '基础数据',
                permission: '/api/locale/search',
                items: [
                    {title: "语法分类", url: "/locale/grammartype", permission: '/api/locale/search',},
                    {title: "题型翻译", url: "/locale/exrtype", permission: '/api/locale/search',},
                    {title: "等级翻译", url: "/locale/level", permission: '/api/locale/search',},
                ]
            },
            {title: "其他翻译", url: "/locale/php"},
        ]
    },
    // {
    //     title: "数据导入",
    //     icon: "el-icon-document",
    //     items: [
    //         {title: "例句拼音修改", url: "/dataupdate"},
    //     ]
    // },
];

export async function getNavItems() {
    const res = await axios.get('/api/user/navs');
    // const res = {data: ['/*']};
    const filter = res.data || [];
    if (filter.includes('/*')) {
        return navItems;
    }
    return filterNavItems(navItems, filter.map(s => {
        s = s.replace(/\*/g, '.*');
        if (!/[\^$]/.test(s)) {
            s = '^(?:' + s + ')$';
        }
        return new RegExp(s);
    }));
}

function filterNavItems(items, filter) {
    const allowItems = items.filter(n => {
        const perm = n.permission || n.url;
        if (perm && !checkAccess(perm, filter)) {
            return false;
        }
        if (n.items) {
            n.items = filterNavItems(n.items, filter);
        }
        return n.url || n.items;
    });
    return allowItems.length ? allowItems : null;
}

function checkAccess(perm, perms) {
    return perms.some(f => f.test(perm));
}